export default __webpack_public_path__ + "static/media/StevenRiva_RL_Project.2eec5db9.pdf";